const LOGIN_INFO_KEY = 'vue_login_info';
const EXPIRATION_TIME = 24 * 60 * 60 * 1000; //一天毫秒数

export default class AuthService {
    /**
     * 保存登录信息到localStorage(24小时过期)
     * @param {Object} userInfo  保存的用户信息（例如：{ username: 'john'})
     */
    static saveLoginInfo(userInfo) {
            const now = Date.now(); // 获取当前时间戳 (毫秒)
            const data = {
                ...userInfo,
                expirationTime: now + EXPIRATION_TIME // 计算过期时间戳
            };
            try {
                localStorage.setItem(LOGIN_INFO_KEY, JSON.stringify(data));
                console.log('登录信息已保存，有效期24小时');
            } catch (error) {
                console.error('保存登录信息失败:', error);
            }
        }
        /**
         * 从 localStorage 获取有效的登录信息
         * @returns {Object|null} 如果信息有效则返回用户信息对象，否则返回 null
         */
    static getLoginInfo() {
        const storedData = localStorage.getItem(LOGIN_INFO_KEY);
        if (!storedData) {
            return null; // 缓存中无数据
        }

        try {
            const data = JSON.parse(storedData);
            const now = Date.now();

            // 检查是否过期
            if (now > data.expirationTime) {
                console.log('登录信息已过期，正在清除...');
                this.removeLoginInfo(); // 清除过期数据
                return null;
            }

            // 返回时不包含 expirationTime 字段
            const { expirationTime, ...userInfo } = data;
            return userInfo;
        } catch (error) {
            console.error('解析登录信息失败:', error);
            // 解析错误，清除无效数据
            this.removeLoginInfo();
            return null;
        }
    }

    /**
     * 立即清除缓存中的登录信息
     */
    static removeLoginInfo() {
        localStorage.removeItem(LOGIN_INFO_KEY);
        console.log('登录信息已清除');
    }

    /**
     * 检查当前登录状态是否有效
     * @returns {Boolean} true 表示有有效登录信息，false 表示无或已过期
     */
    static isLoginValid() {
        return this.getLoginInfo() !== null;
    }
}